import { render, staticRenderFns } from "./SelectCustomerInput.vue?vue&type=template&id=554c9428"
import script from "./SelectCustomerInput.vue?vue&type=script&lang=js"
export * from "./SelectCustomerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports